import {
    ERROR_ACCOUNT_NOT_FILL,
    ERROR_ACCOUNT_PASSWORD_ERROR,
    ERROR_EMAIL_NOT_FILL,
    ERROR_EMAIL_VCODE_NOT_FILL,
    ERROR_PASSWORD_CONFIRM_NOT_FILL,
    ERROR_PASSWORD_NOT_FILL,
    ERROR_PHONE_NOT_FILL,
    ERROR_PWD_NOT_SAME
} from "config/const/error"
import {
    KEY_BTN_FORGETPWD,
    KEY_BTN_RESETPWD,
    KEY_BTN_VAL_ADDED,
    KEY_COL_AMOUNT,
    KEY_COL_APPLIER,
    KEY_COL_LABEL_AMOUNT,
    KEY_COL_LABEL_APPLIER,
    KEY_COL_LABEL_NAME,
    KEY_COL_LABEL_NAME_CN,
    KEY_COL_LABEL_OPERATION,
    KEY_COL_LABEL_PACKAGE,
    KEY_COL_LABEL_STATUS,
    KEY_COL_LABEL_UPDATEDAT,
    KEY_COL_LABEL_USER_EMAIL,
    KEY_COL_LABEL_USER_ENQUIRY_TYPE,
    KEY_COL_LABEL_USER_NAME,
    KEY_COL_LABEL_USER_PHONE,
    KEY_COL_LABEL_USER_TITLE,
    KEY_COL_PACKAGE_CONTENT_CN,
    KEY_COL_PACKAGE_CONTENT_EN,
    KEY_COL_PACKAGE_CONTENT_TC,
    KEY_COL_PACKAGE_DISCOUNT,
    KEY_COL_PACKAGE_DISCOUNT_END,
    KEY_COL_PACKAGE_DISCOUNT_START,
    KEY_COL_PACKAGE_NAME,
    KEY_COL_PACKAGE_PRICE,
    KEY_COL_STATUS,
    KEY_COL_UPDATED_AT,
    KEY_ERROR_ACCOUNT_NOT_FILL,
    KEY_ERROR_ACCOUNT_PASSWORD_ERROR,
    KEY_ERROR_CREATE_FAILED,
    KEY_ERROR_DELETE_FAILED,
    KEY_ERROR_EMAIL_NOT_FILL,
    KEY_ERROR_EMAIL_VCODE_NOT_FILL,
    KEY_ERROR_FORM_EDIT_FAILED,
    KEY_ERROR_FORM_FILL_FORM,
    KEY_ERROR_FORM_SUBMIT_FAILED,
    KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL,
    KEY_ERROR_PASSWORD_NOT_FILL,
    KEY_ERROR_PHONE_NOT_FILL,
    KEY_ERROR_PWD_NOT_SAME,
    KEY_ERROR_REG_FAILED,
    KEY_ERROR_REPLY_FAILED,
    KEY_ERROR_RESET_FAILED,
    KEY_ERROR_SENT_FAILED,
    KEY_ERROR_SENT_INV_FAILED,
    KEY_ERROR_SENT_RECP_FAILED,
    KEY_ERROR_SUG_NOT_FILLED,
    KEY_ERROR_SUG_SENT_FAILED,
    KEY_ERROR_UPDATE_FAILED,
    KEY_ERROR_UPLOADED_FAILED,
    KEY_ERROR_VAL_ADDED_FAILED,
    KEY_FORM_CREDIT_ADD_TO,
    KEY_FORM_CREDIT_TOTAL,
    KEY_FORM_CS_COL_SC_ADDR,
    KEY_FORM_CS_COL_SC_COM,
    KEY_FORM_CS_COL_SC_EMAIL,
    KEY_FORM_CS_COL_SC_NAME_CN,
    KEY_FORM_CS_COL_SC_NAME_EN,
    KEY_FORM_CS_COL_SC_PHONE,
    KEY_FORM_CS_COL_SC_TITLE,
    KEY_FORM_CS_COL_SH_HOLDING,
    KEY_FORM_CS_FILE_COM_POLICY,
    KEY_FORM_CS_FILE_COM_REG,
    KEY_FORM_CS_FILE_DIRECTOR_ADDRESS_VERIFY,
    KEY_FORM_CS_FILE_DIRECTOR_LIST,
    KEY_FORM_CS_FILE_DIRSH_ID,
    KEY_FORM_CS_FILE_MAIN_CTR_LIST,
    KEY_FORM_CS_FILE_NAR1_LAST_YEAR,
    KEY_FORM_CS_FILE_NAR1_UPDATED_LAST_YEAR,
    KEY_FORM_CS_FILE_SH_LIST,
    KEY_FORM_CS_TITLE_1,
    KEY_FORM_CS_TITLE_2,
    KEY_FORM_CS_TITLE_3,
    KEY_FORM_EX_CP_COL_ADDR_CN,
    KEY_FORM_EX_CP_COL_ADDR_EN,
    KEY_FORM_EX_CP_COL_C_EMAIL,
    KEY_FORM_EX_CP_COL_C_PHONE,
    KEY_FORM_EX_CP_COL_ISBILINGUISH,
    KEY_FORM_EX_CP_COL_ISBILINGUISH_CN,
    KEY_FORM_EX_CP_COL_ISBILINGUISH_EN,
    KEY_FORM_EX_CP_COL_ISBILINGUISH_OTHER,
    KEY_FORM_EX_CP_COL_OTHER,
    KEY_FORM_EX_CP_COL_POSITION_CN,
    KEY_FORM_EX_CP_COL_POSITION_EN,
    KEY_FORM_EX_CP_TITLE_1,
    KEY_FORM_EX_CP_TITLE_2,
    KEY_FORM_EX_CS_TITLE_1,
    KEY_FORM_EX_RB_TITLE_1,
    KEY_FORM_EX_RB_TM_DESC,
    KEY_FORM_EX_RB_TM_HOLDER,
    KEY_FORM_EX_RB_TM_HOLDER_ADDR,
    KEY_FORM_EX_RB_TM_HOLDER_BUS,
    KEY_FORM_EX_RB_TM_HOLDER_DIR,
    KEY_FORM_EX_RB_TM_HOLDER_ID,
    KEY_FORM_EX_RB_TM_HOLDER_REG,
    KEY_FORM_EX_RB_TM_ICON,
    KEY_FORM_EX_RB_TM_REG,
    KEY_FORM_EX_RB_TM_TYPE,
    KEY_FORM_TITLE_1,
    KEY_FORM_TITLE_2,
    KEY_FORM_TITLE_3,
    KEY_FORM_TITLE_4,
    KEY_FORM_TITLE_5,
    KEY_FORM_TITLE_6,
    KEY_FORM_VO_COL_BUS_REG_LICENSE,
    KEY_FORM_VO_COL_BUS_REG_LICENSE_NO,
    KEY_FORM_VO_COL_BUS_REG_LICENSE_YES,
    KEY_FORM_VO_COL_BUS_REG_NUM,
    KEY_FORM_VO_COL_FILE_BUG_REG_COPY,
    KEY_FORM_VO_COL_IDENTITY,
    KEY_FORM_VO_COL_IDENTITY_COM,
    KEY_FORM_VO_COL_IDENTITY_IND,
    KEY_FORM_VO_COL_IDENTITY_ORG,
    KEY_FORM_VO_COL_IND_FILE_ADDRESS_COPY,
    KEY_FORM_VO_COL_MAIN_CONTACT,
    KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS,
    KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY,
    KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL,
    KEY_FORM_VO_COL_MAIN_CONTACT_FILE_HKID_COPY,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_GOTOBANK,
    KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_ONLINE,
    KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN,
    KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN,
    KEY_FORM_VO_COL_MAIN_CONTACT_PHONE,
    KEY_FORM_VO_COL_MAIN_CONTACT_TITLE,
    KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS,
    KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR,
    KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS,
    KEY_FORM_VO_COL_NEED_UPLOAD_FILE,
    KEY_FORM_VO_COL_ORG_FILE_ORG_COPY,
    KEY_FORM_VO_COL_ORG_NUM,
    KEY_FORM_VO_COL_REG_CONNTRY,
    KEY_FORM_VO_COL_REG_DATE,
    KEY_FORM_VO_CONFIRM,
    KEY_FORM_VO_TAC_COM_1,
    KEY_FORM_VO_TAC_COM_2,
    KEY_FORM_VO_TAC_COM_3,
    KEY_FORM_VO_TAC_IND_1,
    KEY_FORM_VO_TAC_IND_2,
    KEY_FORM_VO_TAC_ORG_1,
    KEY_FORM_VO_TAC_ORG_2,
    KEY_FORM_VO_TAC_TIPS,
    KEY_FORM_VO_TITLE_1,
    KEY_FORM_VO_TITLE_2,
    KEY_FORM_VO_TITLE_3,
    KEY_FORM_VO_TITLE_4,
    KEY_LABEL_ADDED_RECORD,
    KEY_LABEL_CANCEL,
    KEY_LABEL_CONFIRM,
    KEY_LABEL_CREATE,
    KEY_LABEL_CURRENT_CREDIT,
    KEY_LABEL_DELETE,
    KEY_LABEL_DETAIL,
    KEY_LABEL_EXPORT_AS,
    KEY_LABEL_EXPORT_AS_CSV,
    KEY_LABEL_EXPORT_AS_PDF,
    KEY_LABEL_EXPORT_FILE_FORMAT,
    KEY_LABEL_FORM_ADDRESS,
    KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE,
    KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER,
    KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE,
    KEY_LABEL_FORM_BOARD_COM_REG_ADDR,
    KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM,
    KEY_LABEL_FORM_BOARD_COM_REG_C,
    KEY_LABEL_FORM_BOARD_COM_REG_NUM,
    KEY_LABEL_FORM_BOARD_HOLADING,
    KEY_LABEL_FORM_BOARD_INDENTITY,
    KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY,
    KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR,
    KEY_LABEL_FORM_BOARD_INDENTITY_PERSONAL,
    KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER,
    KEY_LABEL_FORM_BOARD_NO_AFTER,
    KEY_LABEL_FORM_BOARD_NO_BEFORE,
    KEY_LABEL_FORM_BOARD_NUM,
    KEY_LABEL_FORM_BOARD_NUM_NEW,
    KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER,
    KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE,
    KEY_LABEL_FORM_BOARD_SH_CN_NAME,
    KEY_LABEL_FORM_BOARD_SH_EMAIL,
    KEY_LABEL_FORM_BOARD_SH_EN_NAME,
    KEY_LABEL_FORM_BOARD_SH_IC_AFTER,
    KEY_LABEL_FORM_BOARD_SH_IC_BEFORE,
    KEY_LABEL_FORM_BOARD_SH_ID_AFTER,
    KEY_LABEL_FORM_BOARD_SH_ID_BEFORE,
    KEY_LABEL_FORM_BOARD_SH_PHONE,
    KEY_LABEL_FORM_BUS_NATURE,
    KEY_LABEL_FORM_BUS_REGION,
    KEY_LABEL_FORM_CANCEL,
    KEY_LABEL_FORM_COM_ADDR,
    KEY_LABEL_FORM_COM_ADDR_REG,
    KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT,
    KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO,
    KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES,
    KEY_LABEL_FORM_COM_CN_NAME,
    KEY_LABEL_FORM_COM_EN_NAME,
    KEY_LABEL_FORM_CONFIRM,
    KEY_LABEL_FORM_CONTACT_SLOT,
    KEY_LABEL_FORM_CONTACT_SLOT_23,
    KEY_LABEL_FORM_CONTACT_SLOT_35,
    KEY_LABEL_FORM_CONTACT_SLOT_912,
    KEY_LABEL_FORM_CONTACT_WAY,
    KEY_LABEL_FORM_CONTACT_WAY_EMAIL,
    KEY_LABEL_FORM_CONTACT_WAY_PHONE,
    KEY_LABEL_FORM_CONTACT_WAY_WECHAT,
    KEY_LABEL_FORM_CONTACT_WAY_WECHAT_NO,
    KEY_LABEL_FORM_CONTACT_WAY_WTS,
    KEY_LABEL_FORM_EDIT,
    KEY_LABEL_FORM_EMAIL,
    KEY_LABEL_FORM_IS_NUM,
    KEY_LABEL_FORM_NAME,
    KEY_LABEL_FORM_NEXT,
    KEY_LABEL_FORM_PHONE,
    KEY_LABEL_FORM_PIG_MESSAGE,
    KEY_LABEL_FORM_PIG_PLURAL,
    KEY_LABEL_FORM_PIG_ROWS_PER_PAGE,
    KEY_LABEL_FORM_PIG_SELECT_ALL,
    KEY_LABEL_FORM_PIG_SINGULAR,
    KEY_LABEL_FORM_PRESET_SHARES,
    KEY_LABEL_FORM_PRESET_SHARES_EN,
    KEY_LABEL_FORM_PRESET_SHARES_NO,
    KEY_LABEL_FORM_PRESET_SHARES_YES,
    KEY_LABEL_FORM_PREVIEW,
    KEY_LABEL_FORM_PREVIOUS,
    KEY_LABEL_FORM_SUBMIT,
    KEY_LABEL_FORM_TABLE_TITLE,
    KEY_LABEL_FORM_TITLE,
    KEY_LABEL_FORM_TITLE_FEMALE,
    KEY_LABEL_FORM_TITLE_MALE,
    KEY_LABEL_FORM_UPLOADED_FILE,
    KEY_LABEL_FORM_VAL,
    KEY_LABEL_FORM_VALUE_ADDED,
    KEY_LABEL_FORM_VALUE_ADDED_BA,
    KEY_LABEL_FORM_VALUE_ADDED_BE,
    KEY_LABEL_FORM_VALUE_ADDED_CP,
    KEY_LABEL_FORM_VALUE_ADDED_CP_1,
    KEY_LABEL_FORM_VALUE_ADDED_CP_2,
    KEY_LABEL_FORM_VALUE_ADDED_CS,
    KEY_LABEL_FORM_VALUE_ADDED_CSE,
    KEY_LABEL_FORM_VALUE_ADDED_CS_1,
    KEY_LABEL_FORM_VALUE_ADDED_CS_2,
    KEY_LABEL_FORM_VALUE_ADDED_TM,
    KEY_LABEL_FORM_VAL_EN,
    KEY_LABEL_FORM_VAL_TOTAL,
    KEY_LABEL_FORM_VAL_TOTAL_EN,
    KEY_LABEL_HELLO,
    KEY_LABEL_INVOICE,
    KEY_LABEL_NO_DATA_SHOW,
    KEY_LABEL_PAST_RECORD,
    KEY_LABEL_PAY,
    KEY_LABEL_PAYMENT_CANCEL,
    KEY_LABEL_PAYMENT_FAILED,
    KEY_LABEL_PAYMENT_SUCC,
    KEY_LABEL_PROFILE_TITLE,
    KEY_LABEL_RECEIPT,
    KEY_LABEL_RECP_ANNUAL,
    KEY_LABEL_RECP_ANNUAL_END,
    KEY_LABEL_RECP_ANNUAL_START,
    KEY_LABEL_REPLY,
    KEY_LABEL_REPLY_PHD,
    KEY_LABEL_REPLY_TYPE_AS,
    KEY_LABEL_REPLY_TYPE_CS,
    KEY_LABEL_REPLY_TYPE_HKR,
    KEY_LABEL_REPLY_TYPE_OSR,
    KEY_LABEL_REPLY_TYPE_SO,
    KEY_LABEL_REPLY_TYPE_VA,
    KEY_LABEL_REPLY_TYPE_VO,
    KEY_LABEL_RETURN_INDI,
    KEY_LABEL_SEARCH_COMPONENT_TYPE,
    KEY_LABEL_SEND_RECP,
    KEY_LABEL_SUG_EMAIL,
    KEY_LABEL_SUG_ENQUIRY_TYPE,
    KEY_LABEL_SUG_MSG,
    KEY_LABEL_SUG_NAME,
    KEY_LABEL_SUG_PHONE,
    KEY_LABEL_SUG_SEND,
    KEY_LABEL_UPLOAD,
    KEY_LABEL_VALUE_ADDED,
    KEY_LABEL_VAL_ADDED,
    KEY_LABEL_WALLET_CURRENT_CREDIT,
    KEY_LABEL_WALLET_OTHER_PAYMENTS,
    KEY_NOTI_CREATE_SUCC,
    KEY_NOTI_DELETE_SUCC,
    KEY_NOTI_FORM_EDIT_SUCC,
    KEY_NOTI_FORM_SUBMIT_SUCC,
    KEY_NOTI_MSG_DELETE,
    KEY_NOTI_REPLY_SUCC,
    KEY_NOTI_RESET_SUCC,
    KEY_NOTI_SENT,
    KEY_NOTI_SENT_INV_SUCC,
    KEY_NOTI_SENT_RECP_SUCC,
    KEY_NOTI_SUG_SENT_SUCC,
    KEY_NOTI_UPDATE_SUCC,
    KEY_NOTI_UPLOADED_SUCC,
    KEY_PHD_ACCOUNT,
    KEY_PHD_PASSWORD,
    KEY_TEXT_BTN_LOGIN,
    KEY_TEXT_BTN_REG,
    KEY_TEXT_BTN_VCODE,
    KEY_TEXT_FORGETPWD_MODAL_TITLE,
    KEY_TEXT_IPT_EMAIL,
    KEY_TEXT_IPT_EMAIL_VCODE,
    KEY_TEXT_IPT_PHONE,
    KEY_TEXT_IPT_PWD,
    KEY_TEXT_IPT_PWD_CONFIRM,
    KEY_TEXT_LABEL_ACCOUNT,
    KEY_TEXT_LABEL_COMPANY,
    KEY_TEXT_LINK_FORGET_PWD,
    KEY_TEXT_LOGIN_SUCCESSFULLY,
    KEY_TEXT_LOGOUT_SUCCESSFULLY,
    KEY_TEXT_MODAL_TITLE,
    KEY_TEXT_REG_SUCC,
    KEY_TEXT_RESETPWD_MODAL_TITLE,
    KEY_TEXT_SUBTAB_ACCOUNT_BILL_AND_RENEW,
    KEY_TEXT_SUBTAB_ACCOUNT_CONSULT,
    KEY_TEXT_SUBTAB_ACCOUNT_ECARD,
    KEY_TEXT_SUBTAB_ACCOUNT_INFO,
    KEY_TEXT_SUBTAB_ACCOUNT_NOTI,
    KEY_TEXT_SUBTAB_ACCOUNT_PERMISSION,
    KEY_TEXT_SUBTAB_ACCOUNT_SERVICE,
    KEY_TEXT_TAB_ACCOUNT,
    KEY_TEXT_TAB_ACCOUNT_INDIVIDUAL,
    KEY_TEXT_TAB_APPLY_FORM,
    KEY_TEXT_TAB_APPLY_FORM_AS,
    KEY_TEXT_TAB_APPLY_FORM_AS_PROXY,
    KEY_TEXT_TAB_APPLY_FORM_AS_TAX,
    KEY_TEXT_TAB_APPLY_FORM_CS,
    KEY_TEXT_TAB_APPLY_FORM_CS_1,
    KEY_TEXT_TAB_APPLY_FORM_HK,
    KEY_TEXT_TAB_APPLY_FORM_HKL_L,
    KEY_TEXT_TAB_APPLY_FORM_HKUL,
    KEY_TEXT_TAB_APPLY_FORM_HK_L,
    KEY_TEXT_TAB_APPLY_FORM_HK_UL,
    KEY_TEXT_TAB_APPLY_FORM_OS,
    KEY_TEXT_TAB_APPLY_FORM_OS_BVI,
    KEY_TEXT_TAB_APPLY_FORM_OS_CAYMAN,
    KEY_TEXT_TAB_APPLY_FORM_OS_SEYCHELLES,
    KEY_TEXT_TAB_APPLY_FORM_SO,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BAR,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BE,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BNC,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_CSL,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_TR,
    KEY_TEXT_TAB_APPLY_FORM_VO,
    KEY_TEXT_TAB_HOMEPAGE,
    KEY_TEXT_TAB_INDIVIDUAL,
    KEY_TEXT_TAB_MANUAL,
    KEY_TEXT_TAB_REQUEST_SERVICE,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_PROXY,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_TAX,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_CREDITS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_CS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_L,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_UL,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_BVI,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_CAYMAN,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_SEYCHELLES,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_SERVICES,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_SO,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BAR,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BE,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BNC,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_CSL,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_TR,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VO,
    KEY_TEXT_TAB_SUGGESTION_AND_ENQUIRY,
    KEY_TEXT_TAB_USER_MANAGEMENT,
    KEY_TEXT_TAB_WALLET,
    KEY_TEXT_TIPS_I18N,
    KEY_VALUE_100,
    KEY_VALUE_1000,
    KEY_VALUE_200,
    KEY_VALUE_2000,
    KEY_VALUE_3000,
    KEY_VALUE_500,
    MODULE_FORGET_PWD,
    MODULE_INDIVIDUAL,
    MODULE_LOGIN,
    MODULE_PAYMENT,
    MODULE_PREVIEW_ROUTER_FORM,
    MODULE_REG,
    MODULE_REPLY_SELECTION,
    MODULE_RESET_PWD,
    MODULE_SIDEBAR,
    MODULE_SUGGESTION,
    MODULE_UPLOADBTN,
    MODULE_WALLET
} from "config/const/locale"
import {
    TEXT_BTN_FORGET_PWD,
    TEXT_BTN_LOGIN,
    TEXT_BTN_REG,
    TEXT_BTN_VCODE,
    TEXT_IPT_EMAIL,
    TEXT_IPT_EMAIL_VCODE,
    TEXT_IPT_PHONE,
    TEXT_IPT_PWD,
    TEXT_IPT_PWD_CONFIRM,
    TEXT_LABEL_ACCOUNT,
    TEXT_LABEL_COMPANY,
    TEXT_LINK_FORGET_PWD,
    TEXT_LOGIN_SUCCESSFULLY,
    TEXT_LOGOUT_SUCCESSFULLY,
    TEXT_MODAL_TITLE,
    TEXT_PHD_ACCOUNT,
    TEXT_PHD_PASSWORD,
    TEXT_RESET_MODAL_TITLE,
    TEXT_SUBTAB_ACCOUNT_BILL_AND_RENEW,
    TEXT_SUBTAB_ACCOUNT_CONSULT,
    TEXT_SUBTAB_ACCOUNT_ECARD,
    TEXT_SUBTAB_ACCOUNT_INFO,
    TEXT_SUBTAB_ACCOUNT_NOTI,
    TEXT_SUBTAB_ACCOUNT_PERMISSION,
    TEXT_SUBTAB_ACCOUNT_SERVICE,
    TEXT_TAB_ACCOUNT,
    TEXT_TAB_ACCOUNT_INDIVIDUAL,
    TEXT_TAB_HOMEPAGE,
    TEXT_TAB_MANUAL,
    TEXT_TAB_REQUEST_SERVICE,
    TEXT_TAB_SUGGESTION_AND_ENQUIRY,
    TEXT_TAB_WALLET
} from "config/const/text"


export default {
    [MODULE_LOGIN]: {
        [KEY_TEXT_MODAL_TITLE]: TEXT_MODAL_TITLE,
        [KEY_PHD_ACCOUNT]: TEXT_PHD_ACCOUNT,
        [KEY_PHD_PASSWORD]: TEXT_PHD_PASSWORD,
        [KEY_TEXT_BTN_LOGIN]: TEXT_BTN_LOGIN,
        [KEY_TEXT_LINK_FORGET_PWD]: TEXT_LINK_FORGET_PWD,
        [KEY_TEXT_LOGIN_SUCCESSFULLY]: TEXT_LOGIN_SUCCESSFULLY,
        [KEY_ERROR_ACCOUNT_NOT_FILL]: ERROR_ACCOUNT_NOT_FILL,
        [KEY_ERROR_PASSWORD_NOT_FILL]: ERROR_PASSWORD_NOT_FILL,
        [KEY_ERROR_ACCOUNT_PASSWORD_ERROR]: ERROR_ACCOUNT_PASSWORD_ERROR,
        [KEY_TEXT_BTN_REG]: TEXT_BTN_REG,
    },
    [MODULE_REG]: {
        [KEY_TEXT_IPT_EMAIL]: TEXT_IPT_EMAIL,
        [KEY_TEXT_IPT_EMAIL_VCODE]: TEXT_IPT_EMAIL_VCODE,
        [KEY_TEXT_BTN_VCODE]: TEXT_BTN_VCODE,
        [KEY_TEXT_IPT_PHONE]: TEXT_IPT_PHONE,
        [KEY_TEXT_IPT_PWD]: TEXT_IPT_PWD,
        [KEY_TEXT_BTN_LOGIN]: TEXT_BTN_LOGIN,
        [KEY_TEXT_IPT_PWD_CONFIRM]: TEXT_IPT_PWD_CONFIRM,
        [KEY_TEXT_BTN_REG]: TEXT_BTN_REG,
        [KEY_TEXT_REG_SUCC]: '註冊成功',
        [KEY_ERROR_EMAIL_NOT_FILL]: ERROR_EMAIL_NOT_FILL,
        [KEY_ERROR_EMAIL_VCODE_NOT_FILL]: ERROR_EMAIL_VCODE_NOT_FILL,
        [KEY_ERROR_PHONE_NOT_FILL]: ERROR_PHONE_NOT_FILL,
        [KEY_ERROR_PASSWORD_NOT_FILL]: ERROR_PASSWORD_NOT_FILL,
        [KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL]: ERROR_PASSWORD_CONFIRM_NOT_FILL,
        [KEY_ERROR_PWD_NOT_SAME]: ERROR_PWD_NOT_SAME,
        [KEY_ERROR_REG_FAILED]: '註冊失敗'
    },
    [MODULE_FORGET_PWD]: {
        [KEY_TEXT_FORGETPWD_MODAL_TITLE]: TEXT_LINK_FORGET_PWD,
        [KEY_TEXT_IPT_EMAIL]: TEXT_IPT_EMAIL,
        [KEY_BTN_FORGETPWD]: TEXT_BTN_FORGET_PWD,
        [KEY_TEXT_BTN_LOGIN]: TEXT_BTN_LOGIN,
        [KEY_NOTI_SENT]: '已發送，請留意電郵',
        [KEY_ERROR_EMAIL_NOT_FILL]: ERROR_EMAIL_NOT_FILL,
        [KEY_ERROR_SENT_FAILED]: '發送失敗'
    },
    [MODULE_RESET_PWD]: {
        [KEY_TEXT_IPT_PWD]: TEXT_IPT_PWD,
        [KEY_TEXT_IPT_PWD_CONFIRM]: TEXT_IPT_PWD_CONFIRM,
        [KEY_ERROR_PASSWORD_NOT_FILL]: ERROR_PASSWORD_NOT_FILL,
        [KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL]: ERROR_PASSWORD_CONFIRM_NOT_FILL,
        [KEY_ERROR_PWD_NOT_SAME]: ERROR_PWD_NOT_SAME,
        [KEY_TEXT_RESETPWD_MODAL_TITLE]: TEXT_RESET_MODAL_TITLE,
        [KEY_BTN_RESETPWD]: TEXT_IPT_PWD_CONFIRM,
        [KEY_NOTI_RESET_SUCC]: '已更改密碼',
        [KEY_ERROR_RESET_FAILED]: '更改失敗'
    },
    [MODULE_SIDEBAR]: {
        [KEY_TEXT_MODAL_TITLE]: TEXT_MODAL_TITLE,
        [KEY_TEXT_LABEL_ACCOUNT]: TEXT_LABEL_ACCOUNT,
        [KEY_TEXT_LABEL_COMPANY]: TEXT_LABEL_COMPANY,
        [KEY_TEXT_TAB_HOMEPAGE]: TEXT_TAB_HOMEPAGE,
        [KEY_TEXT_TAB_ACCOUNT]: TEXT_TAB_ACCOUNT,
        [KEY_TEXT_SUBTAB_ACCOUNT_INFO]: TEXT_SUBTAB_ACCOUNT_INFO,
        [KEY_TEXT_SUBTAB_ACCOUNT_CONSULT]: TEXT_SUBTAB_ACCOUNT_CONSULT,
        [KEY_TEXT_SUBTAB_ACCOUNT_SERVICE]: TEXT_SUBTAB_ACCOUNT_SERVICE,
        [KEY_TEXT_SUBTAB_ACCOUNT_ECARD]: TEXT_SUBTAB_ACCOUNT_ECARD,
        [KEY_TEXT_SUBTAB_ACCOUNT_NOTI]: TEXT_SUBTAB_ACCOUNT_NOTI,
        [KEY_TEXT_SUBTAB_ACCOUNT_BILL_AND_RENEW]: TEXT_SUBTAB_ACCOUNT_BILL_AND_RENEW,
        [KEY_TEXT_SUBTAB_ACCOUNT_PERMISSION]: TEXT_SUBTAB_ACCOUNT_PERMISSION,
        [KEY_TEXT_TAB_ACCOUNT_INDIVIDUAL]: TEXT_TAB_ACCOUNT_INDIVIDUAL,
        [KEY_TEXT_TAB_WALLET]: TEXT_TAB_WALLET,
        [KEY_TEXT_TAB_REQUEST_SERVICE]: TEXT_TAB_REQUEST_SERVICE,
        [KEY_TEXT_TAB_MANUAL]: TEXT_TAB_MANUAL,
        [KEY_TEXT_TAB_SUGGESTION_AND_ENQUIRY]: TEXT_TAB_SUGGESTION_AND_ENQUIRY,
        [KEY_TEXT_LOGOUT_SUCCESSFULLY]: TEXT_LOGOUT_SUCCESSFULLY,
        [KEY_TEXT_TAB_USER_MANAGEMENT]: '用户管理',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT]: '服務管理',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_SERVICES]: '套餐管理',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_CREDITS]: '點數管理',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK]: '香港境內公司',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_L]: '有限公司',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_UL]: '無限公司',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS]: '香港境外公司',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_BVI]: 'BVI',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_CAYMAN]: '開曼',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_SEYCHELLES]: '塞舌爾',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_SO]: '服務式辦公室',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_VO]: '虛擬辦公室',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_CS]: '公司秘書服務',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS]: '會計服務',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_PROXY]: '會計報稅',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_TAX]: '代理會計',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED]: '增值服務',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BE]: '企業電郵',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BNC]: '卡片印刷',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_CSL]: '定製印章',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_TR]: '註冊商標',
        [KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BAR]: '銀行户口',
        [KEY_TEXT_TAB_INDIVIDUAL]: '個人帳户',
        [KEY_TEXT_TAB_APPLY_FORM]: '服務管理',
        [KEY_TEXT_TAB_APPLY_FORM_HK]: '香港境內公司',
        [KEY_TEXT_TAB_APPLY_FORM_HK_L]: '有限公司',
        [KEY_TEXT_TAB_APPLY_FORM_HK_UL]: '無限公司',
        [KEY_TEXT_TAB_APPLY_FORM_OS]: '香港境外公司',
        [KEY_TEXT_TAB_APPLY_FORM_OS_BVI]: 'BVI',
        [KEY_TEXT_TAB_APPLY_FORM_OS_CAYMAN]: '開曼',
        [KEY_TEXT_TAB_APPLY_FORM_OS_SEYCHELLES]: '塞舌爾',
        [KEY_TEXT_TAB_APPLY_FORM_SO]: '服務式辦公室',
        [KEY_TEXT_TAB_APPLY_FORM_VO]: '虛擬辦公室',
        [KEY_TEXT_TAB_APPLY_FORM_CS]: '公司秘書服務',
        [KEY_TEXT_TAB_APPLY_FORM_CS_1]: '代辦周年申報表服務',
        [KEY_TEXT_TAB_APPLY_FORM_AS]: '會計服務',
        [KEY_TEXT_TAB_APPLY_FORM_AS_PROXY]: '會計報稅',
        [KEY_TEXT_TAB_APPLY_FORM_AS_TAX]: '"代理會計',
        // [KEY_TEXT_TAB_APPLY_FORM_AS]: '會計服務(即將推出)',
        // [KEY_TEXT_TAB_APPLY_FORM_AS_PROXY]: '會計報稅(即將推出)',
        // [KEY_TEXT_TAB_APPLY_FORM_AS_TAX]: '"代理會計(即將推出)',
        [KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED]: '增值服務',
        [KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BE]: '企業電郵',
        [KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BNC]: '卡片印刷',
        [KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_CSL]: '定製印章',
        [KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_TR]: '註冊商標',
        [KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BAR]: '銀行户口',
        [KEY_TEXT_TIPS_I18N]: '請轉換語言後刷新界面'
    },
    [MODULE_INDIVIDUAL]: {
        [KEY_COL_LABEL_NAME]: '公司名稱',
        [KEY_COL_LABEL_NAME_CN]: '公司中文名稱',
        [KEY_COL_LABEL_APPLIER]: '申請人',
        [KEY_COL_LABEL_PACKAGE]: '套餐/服務',
        [KEY_COL_LABEL_UPDATEDAT]: '更新時間',
        [KEY_COL_LABEL_STATUS]: '狀態',
        [KEY_COL_LABEL_OPERATION]: '操作',
        [KEY_NOTI_SENT_RECP_SUCC]: '發出成功',
        [KEY_ERROR_SENT_RECP_FAILED]: '發出失敗',
        [KEY_NOTI_SENT_INV_SUCC]: '獲取成功',
        [KEY_ERROR_SENT_INV_FAILED]: '獲取失敗',
        [KEY_LABEL_DETAIL]: '詳情',
        [KEY_LABEL_INVOICE]: '發票',
        [KEY_LABEL_RECEIPT]: '收據',
        [KEY_LABEL_HELLO]: '你好',
        [KEY_LABEL_CURRENT_CREDIT]: '目前Credit為：',
        [KEY_LABEL_VALUE_ADDED]: '增值',
        [KEY_LABEL_ADDED_RECORD]: '申請記錄',
        [KEY_LABEL_SEND_RECP]: '發出收據',
        [KEY_LABEL_RECP_ANNUAL]: '報表年度',
        [KEY_LABEL_RECP_ANNUAL_START]: '發出日期',
        [KEY_LABEL_RECP_ANNUAL_END]: '到期日期',
        [KEY_LABEL_CONFIRM]: '確定',
        [KEY_LABEL_CANCEL]: '取消',
    },
    [MODULE_UPLOADBTN]: {
        [KEY_LABEL_UPLOAD]: '上傳文件',
        [KEY_NOTI_UPLOADED_SUCC]: '上傳成功',
        [KEY_ERROR_UPLOADED_FAILED]: '上傳失敗',
    },
    [MODULE_PREVIEW_ROUTER_FORM]: {
        [KEY_FORM_TITLE_1]: '聯絡人資料',
        [KEY_FORM_TITLE_2]: '所選擇之服務計劃',
        [KEY_FORM_TITLE_3]: '成立/購買現成有限公司資料',
        [KEY_FORM_TITLE_4]: '發行股本',
        [KEY_FORM_TITLE_5]: '請選擇董事及創辦成員成員數目',
        [KEY_FORM_TITLE_6]: '增值服務',
        [KEY_LABEL_FORM_NAME]: '*姓名:',
        [KEY_LABEL_FORM_TITLE]: '*稱謂:',
        [KEY_LABEL_FORM_PHONE]: '*電話:',
        [KEY_LABEL_FORM_EMAIL]: '*電郵:',
        [KEY_LABEL_FORM_ADDRESS]: '地址:',
        [KEY_LABEL_FORM_CONTACT_WAY]: '希望我們以什麼方式聯繫:',
        [KEY_LABEL_FORM_CONTACT_SLOT]: '希望我們什麼時間聯繫您:',
        [KEY_LABEL_FORM_COM_EN_NAME]: '公司英文名稱:',
        [KEY_LABEL_FORM_COM_CN_NAME]: '公司中文名稱:',
        [KEY_LABEL_FORM_COM_ADDR]: '*公司通訊地址(如套餐包含虛擬地址服務，則該項默認為虛擬地址):',
        [KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT]: '*選用匯盟地址作為註冊地址:',
        [KEY_LABEL_FORM_COM_ADDR_REG]: '*註冊地址:',
        [KEY_LABEL_FORM_PRESET_SHARES]: '*預設註冊資本為1港幣，分作 1 股，每股面值 1港幣:',
        [KEY_LABEL_FORM_PRESET_SHARES_EN]: '*預設註冊資本為1美元，分作 1 股，每股面值 1美元:',
        [KEY_LABEL_FORM_IS_NUM]: '發行股數:',
        [KEY_LABEL_FORM_VAL]: '每股面值（港幣）:',
        [KEY_LABEL_FORM_VAL_EN]: '每股面值（美元）:',
        [KEY_LABEL_FORM_VAL_TOTAL]: '總面值（港幣）:',
        [KEY_LABEL_FORM_VAL_TOTAL_EN]: '總面值（美元）:',
        [KEY_LABEL_FORM_BUS_NATURE]: '*業務性質:',
        [KEY_LABEL_FORM_BUS_REGION]: '*業務地區:',
        [KEY_LABEL_FORM_BOARD_NUM]: '請選擇董事及創辦成員成員數目:',
        [KEY_LABEL_FORM_VALUE_ADDED]: '增值服務:',
        [KEY_LABEL_FORM_UPLOADED_FILE]: '上傳文件:',
        [KEY_LABEL_FORM_BOARD_NO_BEFORE]: '*第',
        [KEY_LABEL_FORM_BOARD_NO_AFTER]: '名股東:',
        [KEY_LABEL_FORM_BOARD_INDENTITY]: '*身份:',
        [KEY_LABEL_FORM_BOARD_HOLADING]: '股份數目:',
        [KEY_LABEL_FORM_BOARD_SH_EN_NAME]: '名股東/董事英文名稱:',
        [KEY_LABEL_FORM_BOARD_SH_CN_NAME]: '名股東/董事中文名稱:',
        [KEY_LABEL_FORM_BOARD_SH_PHONE]: '*電話:',
        [KEY_LABEL_FORM_BOARD_SH_EMAIL]: '*電郵:',
        [KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE]: '*住址 (第',
        [KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER]: '名股東/董事):',
        [KEY_LABEL_FORM_BOARD_SH_ID_BEFORE]: '*身份証/護照 (第',
        [KEY_LABEL_FORM_BOARD_SH_ID_AFTER]: '名股東/董事):',
        [KEY_LABEL_FORM_BOARD_SH_IC_BEFORE]: '*簽發國家 (第',
        [KEY_LABEL_FORM_BOARD_SH_IC_AFTER]: '名股東/董事):',
        [KEY_LABEL_FORM_BOARD_COM_REG_ADDR]: '*公司註冊住址 （如身份是公司）:',
        [KEY_LABEL_FORM_BOARD_COM_REG_NUM]: '*公司註冊號碼 （如身份是公司）:',
        [KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM]: '*商業登記證號碼 （如身份是公司）:',
        [KEY_LABEL_FORM_BOARD_COM_REG_C]: '*註冊國家 （如身份是公司）:',
        [KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE]: '詳細資金來源（如身份是公司）',
        [KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE]: '詳細資金來源 (第',
        [KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER]: '名股東/董事)',
        [KEY_NOTI_FORM_EDIT_SUCC]: '更改成功',
        [KEY_ERROR_FORM_EDIT_FAILED]: '更改失敗',
        [KEY_LABEL_FORM_EDIT]: '編輯',
        [KEY_LABEL_FORM_CONFIRM]: '完成',
        [KEY_LABEL_FORM_CANCEL]: '取消',
        [KEY_LABEL_FORM_TITLE_MALE]: '先生',
        [KEY_LABEL_FORM_TITLE_FEMALE]: '小姐',
        [KEY_LABEL_FORM_CONTACT_WAY_WTS]: 'whatsapp',
        [KEY_LABEL_FORM_CONTACT_WAY_PHONE]: '電話',
        [KEY_LABEL_FORM_CONTACT_WAY_EMAIL]: '電郵',
        [KEY_LABEL_FORM_CONTACT_WAY_WECHAT]: '微信',
        [KEY_LABEL_FORM_CONTACT_WAY_WECHAT_NO]: '你的微信',
        [KEY_LABEL_FORM_CONTACT_SLOT_912]: '9am -12pm',
        [KEY_LABEL_FORM_CONTACT_SLOT_23]: '2-3pm',
        [KEY_LABEL_FORM_CONTACT_SLOT_35]: '3-5:30pm',
        [KEY_LABEL_FORM_PRESET_SHARES_YES]: '是',
        [KEY_LABEL_FORM_PRESET_SHARES_NO]: '否',
        [KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES]: '是',
        [KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO]: '否',
        [KEY_LABEL_FORM_BOARD_NUM_NEW]: '新增',
        [KEY_LABEL_FORM_VALUE_ADDED_BE]: '企業電郵（另需報價）',
        [KEY_LABEL_FORM_VALUE_ADDED_CP]: '卡片印刷',
        [KEY_LABEL_FORM_VALUE_ADDED_CP_1]: '卡片印刷 100 張',
        [KEY_LABEL_FORM_VALUE_ADDED_CP_2]: '卡片印刷 200 張',
        [KEY_LABEL_FORM_VALUE_ADDED_CS]: '定制印章',
        [KEY_LABEL_FORM_VALUE_ADDED_CS_1]: '簽字章',
        [KEY_LABEL_FORM_VALUE_ADDED_CS_2]: '圓章',
        [KEY_LABEL_FORM_VALUE_ADDED_BA]: '申請銀行賬戶（另需報價）',
        [KEY_LABEL_FORM_VALUE_ADDED_TM]: '註冊商標（另需報價）',
        [KEY_LABEL_FORM_VALUE_ADDED_CSE]: '公司秘書',
        [KEY_LABEL_FORM_PREVIOUS]: '上一步',
        [KEY_LABEL_FORM_NEXT]: '下一步',
        [KEY_LABEL_FORM_PREVIEW]: '預覽',
        [KEY_LABEL_FORM_SUBMIT]: '遞交',
        [KEY_ERROR_FORM_FILL_FORM]: '請填寫完資料',
        [KEY_NOTI_FORM_SUBMIT_SUCC]: '提交成功',
        [KEY_ERROR_FORM_SUBMIT_FAILED]: '提交失敗',
        [KEY_LABEL_FORM_BOARD_INDENTITY_PERSONAL]: '個人',
        [KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY]: '公司',
        [KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR]: '董事',
        [KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER]: '股東',
        [KEY_COL_LABEL_NAME]: '公司名稱',
        [KEY_COL_LABEL_NAME_CN]: '公司中文名稱',
        [KEY_COL_LABEL_APPLIER]: '申請人',
        [KEY_COL_LABEL_PACKAGE]: '套餐/服務',
        [KEY_COL_LABEL_AMOUNT]: '銀碼',
        [KEY_COL_LABEL_UPDATEDAT]: '更新時間',
        [KEY_COL_LABEL_STATUS]: '狀態',
        [KEY_COL_LABEL_OPERATION]: '操作',
        [KEY_LABEL_EXPORT_AS]: '導出為',
        [KEY_LABEL_EXPORT_AS_CSV]: 'CSV',
        [KEY_LABEL_EXPORT_AS_PDF]: 'PDF',
        [KEY_NOTI_MSG_DELETE]: '一旦刪除將無法恢復，確定嗎？',
        [KEY_LABEL_DELETE]: '刪除',
        [KEY_LABEL_EXPORT_FILE_FORMAT]: '帳户總覽.pdf',
        [KEY_LABEL_FORM_TABLE_TITLE]: '帳户總覽',
        [KEY_LABEL_FORM_PIG_SINGULAR]: '個項目',
        [KEY_LABEL_FORM_PIG_PLURAL]: '個項目',
        [KEY_LABEL_FORM_PIG_MESSAGE]: '選中',
        [KEY_LABEL_FORM_PIG_ROWS_PER_PAGE]: '每頁:',
        [KEY_LABEL_FORM_PIG_SELECT_ALL]: '全部',
        [KEY_COL_LABEL_USER_NAME]: '用户名',
        [KEY_COL_LABEL_USER_PHONE]: '電話',
        [KEY_COL_LABEL_USER_EMAIL]: '電郵',
        [KEY_COL_LABEL_USER_TITLE]: '稱謂',
        [KEY_NOTI_DELETE_SUCC]: '刪除成功',
        [KEY_ERROR_DELETE_FAILED]: '刪除失敗',
        [KEY_NOTI_UPDATE_SUCC]: '修改成功',
        [KEY_ERROR_UPDATE_FAILED]: '修改失敗',
        [KEY_LABEL_PROFILE_TITLE]: '修改個人信息',
        [KEY_COL_LABEL_USER_ENQUIRY_TYPE]: '咨詢類型',
        [KEY_NOTI_REPLY_SUCC]: '已回覆',
        [KEY_ERROR_REPLY_FAILED]: '回覆失敗',
        [KEY_LABEL_REPLY_PHD]: '請填寫回覆電郵',
        [KEY_LABEL_REPLY]: '回覆',
        [KEY_LABEL_SEARCH_COMPONENT_TYPE]: '類型',
        [KEY_NOTI_CREATE_SUCC]: '新增成功',
        [KEY_ERROR_CREATE_FAILED]: '新增失敗',
        [KEY_LABEL_CREATE]: '創建',
        [KEY_LABEL_CANCEL]: '取消',
        [KEY_LABEL_NO_DATA_SHOW]: '暫時沒有數據顯示',
        [KEY_COL_PACKAGE_NAME]: '套餐',
        [KEY_COL_PACKAGE_PRICE]: '價錢',
        [KEY_COL_PACKAGE_CONTENT_TC]: '繁中內容',
        [KEY_COL_PACKAGE_CONTENT_CN]: '簡中內容',
        [KEY_COL_PACKAGE_CONTENT_EN]: '英文內容',
        [KEY_COL_PACKAGE_DISCOUNT]: '折扣',
        [KEY_COL_PACKAGE_DISCOUNT_START]: '折扣開始時間',
        [KEY_COL_PACKAGE_DISCOUNT_END]: '折扣結束時間',

        // 20240719 new
        [KEY_FORM_VO_TITLE_1]: '填寫公司資料',
        [KEY_FORM_VO_TITLE_2]: '虛擬辦公室聯絡人',
        [KEY_FORM_VO_TITLE_3]: '增值服務',
        [KEY_FORM_VO_TITLE_4]: '完成結束',
        [KEY_FORM_VO_COL_IDENTITY]: '選擇申請身份',
        [KEY_FORM_VO_COL_IDENTITY_COM]: '香港公司/無限公司/其他',
        [KEY_FORM_VO_COL_IDENTITY_IND]: '個人',
        [KEY_FORM_VO_COL_IDENTITY_ORG]: '團體組織',
        [KEY_FORM_VO_COL_BUS_REG_LICENSE]: '商業登記證',
        [KEY_FORM_VO_COL_BUS_REG_LICENSE_YES]: '有',
        [KEY_FORM_VO_COL_BUS_REG_LICENSE_NO]: '無',
        [KEY_FORM_VO_COL_REG_DATE]: '註冊日期',
        [KEY_FORM_VO_COL_BUS_REG_NUM]: '商業登記號碼',
        [KEY_FORM_VO_COL_NEED_UPLOAD_FILE]: '需上載文件（可於‘個人帳户->申請記錄->上傳文件’處補交文件）',
        [KEY_FORM_VO_COL_FILE_BUG_REG_COPY]: '1、商業登記證副本（如有公司登記證書副本）',
        [KEY_FORM_VO_COL_MAIN_CONTACT]: '主要聯絡人（至少一名，可多名）',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY]: '聯絡人身份',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR]: '董事',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH]: '股東',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY]: '公司秘書',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF]: '職員',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT]: '代理人',
        [KEY_FORM_VO_COL_MAIN_CONTACT_TITLE]: '稱呼',
        [KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR]: '先生',
        [KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS]: '小姐',
        [KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS]: '女士',
        [KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN]: '英文姓名',
        [KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN]: '中文姓名',
        [KEY_FORM_VO_COL_MAIN_CONTACT_PHONE]: '聯絡電話',
        [KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL]: '聯絡電郵',
        [KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS]: '通訊地址',
        [KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY]: '出生年月日',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY]: '核實身份',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_GOTOBANK]: '1、親身到分行',
        [KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_ONLINE]: '2、視訊',
        [KEY_FORM_VO_COL_MAIN_CONTACT_FILE_HKID_COPY]: '1、聯絡人證件',
        [KEY_FORM_VO_CONFIRM]: '確認並提交申請',
        [KEY_FORM_VO_TAC_COM_1]: '1、本人明白必須於12日內或按客戶服務員指引盡快交回簽署好的文件以完成相關程序，否則引起的罰款或後果本人需要自行承擔。本人亦明白如果1個月內我未有提交足以完成申請服務的文件，將被視為放棄服務，我將不會得到退款，繼續服務需重新收費。',
        [KEY_FORM_VO_TAC_COM_2]: '2、我確定這不是上市公司，我清楚如果虛報將被即時終止服務。',
        [KEY_FORM_VO_TAC_COM_3]: '3、我確定以上所填寫資料準確無誤,並已閱讀及同意 虛擬辦公室服務條款 ,我同意如果由於上述資料錯誤而產生任何問題或行政費將由我負責。',
        [KEY_FORM_VO_TAC_TIPS]: '*提交表格即代表同意上述條款',
        [KEY_FORM_VO_COL_IND_FILE_ADDRESS_COPY]: '1、地址證明副本',
        [KEY_FORM_VO_COL_REG_CONNTRY]: '註冊國家',
        [KEY_FORM_VO_COL_ORG_NUM]: '團隊組織號碼',
        [KEY_FORM_VO_COL_ORG_FILE_ORG_COPY]: '1、團隊組織證明副本',
        [KEY_FORM_VO_TAC_IND_1]: '1、本人明白必须于12日内或按客户服务员指引尽快交回签署好的文件以完成相关程序，否则引起的罚款或后果本人需要自行承担。本人亦明白如果1个月内我未有提交足以完成申请服务的文件，将被视作放弃服务，我将不会得到退款，继续服务需重新收费。',
        [KEY_FORM_VO_TAC_IND_2]: '2、我确定以上所填写资料准确无误,并已阅读及同意 虚拟办公室服务条款 ,我同意如果由于上述资料错误而产生任何问题或行政费将由我负责。',
        [KEY_FORM_VO_TAC_ORG_1]: '1、本人明白必须于12日内或按客户服务员指引尽快交回签署好的文件以完成相关程序，否则引起的罚款或后果本人需要自行承担。本人亦明白如果1个月内我未有提交足以完成申请服务的文件，将被视作放弃服务，我将不会得到退款，继续服务需重新收费。',
        [KEY_FORM_VO_TAC_ORG_2]: '2、我确定以上所填写资料准确无误,并已阅读及同意 虚拟办公室服务条款 ,我同意如果由于上述资料错误而产生任何问题或行政费将由我负责。',
        [KEY_FORM_CS_FILE_COM_REG]: '2、公司註冊證',
        [KEY_FORM_CS_FILE_COM_POLICY]: '3、公司章程',
        [KEY_FORM_CS_FILE_DIRECTOR_LIST]: '4、董事名冊',
        [KEY_FORM_CS_FILE_SH_LIST]: '5、股東名冊',
        [KEY_FORM_CS_FILE_MAIN_CTR_LIST]: '6、主要控製人登記冊',
        [KEY_FORM_CS_FILE_NAR1_LAST_YEAR]: '- 上年申報 NAR1 表格',
        [KEY_FORM_CS_FILE_NAR1_UPDATED_LAST_YEAR]: '- 上年度提交 NAR1 後是否有提交其他變更文件或轉股文件（如有都需上傳）',
        [KEY_FORM_CS_FILE_DIRSH_ID]: '1、身份證/護照/通行證副本',
        [KEY_FORM_CS_FILE_DIRECTOR_ADDRESS_VERIFY]: '2、地址證明',
        [KEY_FORM_CS_TITLE_1]: '公司資料',
        [KEY_FORM_CS_TITLE_2]: '董事/股東資料',
        [KEY_FORM_CS_TITLE_3]: '秘書公司（如非本公司）',
        [KEY_FORM_CS_COL_SH_HOLDING]: '持股數量',
        [KEY_FORM_CS_COL_SC_COM]: '秘書公司（如非本公司）',
        [KEY_FORM_CS_COL_SC_TITLE]: '稱呼',
        [KEY_FORM_CS_COL_SC_NAME_CN]: '中文名稱',
        [KEY_FORM_CS_COL_SC_NAME_EN]: '英文名稱',
        [KEY_FORM_CS_COL_SC_PHONE]: '聯繫電話',
        [KEY_FORM_CS_COL_SC_EMAIL]: '聯繫電郵',
        [KEY_FORM_CS_COL_SC_ADDR]: '通許地址',
        [KEY_FORM_EX_CP_TITLE_1]: '聯絡人資料',
        [KEY_FORM_EX_CP_TITLE_2]: '提供名片上資料',
        [KEY_FORM_EX_CP_COL_ISBILINGUISH]: '選擇卡片語言',
        [KEY_FORM_EX_CP_COL_ISBILINGUISH_CN]: '中文',
        [KEY_FORM_EX_CP_COL_ISBILINGUISH_EN]: '英文',
        [KEY_FORM_EX_CP_COL_ISBILINGUISH_OTHER]: '其他',
        [KEY_FORM_EX_CP_COL_POSITION_CN]: '中文職稱',
        [KEY_FORM_EX_CP_COL_POSITION_EN]: '英文職稱',
        [KEY_FORM_EX_CP_COL_ADDR_CN]: '中文聯絡地址',
        [KEY_FORM_EX_CP_COL_ADDR_EN]: '英文聯絡地址',
        [KEY_FORM_EX_CP_COL_OTHER]: '備註',
        [KEY_FORM_EX_CP_COL_C_PHONE]: '聯絡電話',
        [KEY_FORM_EX_CP_COL_C_EMAIL]: '聯絡電郵',
        [KEY_FORM_EX_CS_TITLE_1]: '印章中英文公司名稱',
        [KEY_FORM_EX_RB_TITLE_1]: '填寫商標信息',
        [KEY_FORM_EX_RB_TM_REG]: '商標註冊地',
        [KEY_FORM_EX_RB_TM_HOLDER]: '商標擁有人姓名',
        [KEY_FORM_EX_RB_TM_HOLDER_ADDR]: '商標擁有人通訊地址',
        [KEY_FORM_EX_RB_TM_HOLDER_ID]: '- 個人身份證件(如商標擁有人為個人則需要上載)',
        [KEY_FORM_EX_RB_TM_HOLDER_BUS]: '- 商業登記證件(如商標擁有人為公司則需要上載)',
        [KEY_FORM_EX_RB_TM_HOLDER_REG]: '- 公司註冊證明(如商標擁有人為公司則需要上載)',
        [KEY_FORM_EX_RB_TM_HOLDER_DIR]: '- 任意一名董事資料(如商標擁有人為公司則需要上載)',
        [KEY_FORM_EX_RB_TM_ICON]: '- 擬註冊商標之圖案',
        [KEY_FORM_EX_RB_TM_TYPE]: '擬註冊商標之類別',
        [KEY_FORM_EX_RB_TM_DESC]: '擬註冊商標之詳細說明',

        [KEY_FORM_CREDIT_TOTAL]: '點數總額',
        [KEY_FORM_CREDIT_ADD_TO]: '為該帳户增值',
        [KEY_LABEL_CONFIRM]: '確定'
    },
    [MODULE_PAYMENT]: {
        [KEY_LABEL_PAY]: '付款',
        [KEY_LABEL_VAL_ADDED]: '增值',
        [KEY_LABEL_RETURN_INDI]: '返回個人帳户',
        [KEY_LABEL_PAYMENT_SUCC]: '成功',
        [KEY_LABEL_PAYMENT_FAILED]: '失敗',
        [KEY_LABEL_PAYMENT_CANCEL]: '取消',
    },
    [MODULE_SUGGESTION]: {
        [KEY_ERROR_SUG_NOT_FILLED]: '請填寫完整',
        [KEY_NOTI_SUG_SENT_SUCC]: '發送成功',
        [KEY_ERROR_SUG_SENT_FAILED]: '發送失敗',
        [KEY_LABEL_SUG_ENQUIRY_TYPE]: '查詢類型',
        [KEY_LABEL_SUG_NAME]: '姓名',
        [KEY_LABEL_SUG_EMAIL]: '電郵',
        [KEY_LABEL_SUG_PHONE]: '電話',
        [KEY_LABEL_SUG_MSG]: '正文',
        [KEY_LABEL_SUG_SEND]: '送出'
    },
    [MODULE_WALLET]: {
        [KEY_COL_APPLIER]: '申請人',
        [KEY_COL_AMOUNT]: '銀碼',
        [KEY_COL_UPDATED_AT]: '更新時間',
        [KEY_COL_STATUS]: '狀態',
        [KEY_ERROR_VAL_ADDED_FAILED]: '增值失敗',
        [KEY_LABEL_WALLET_CURRENT_CREDIT]: 'Credit增值金額：',
        [KEY_LABEL_WALLET_OTHER_PAYMENTS]: '其他增值方式（成功付款後請聯絡管理員）：',
        [KEY_VALUE_100]: '100HKD',
        [KEY_VALUE_200]: '200HKD',
        [KEY_VALUE_500]: '500HKD',
        [KEY_VALUE_1000]: '1000HKD',
        [KEY_VALUE_2000]: '2000HKD',
        [KEY_VALUE_3000]: '3000HKD',
        [KEY_BTN_VAL_ADDED]: '增值',
        [KEY_LABEL_PAST_RECORD]: '過往增值記錄'
    },
    [MODULE_REPLY_SELECTION]: {
        [KEY_LABEL_REPLY_TYPE_HKR]: '註冊香港公司',
        [KEY_LABEL_REPLY_TYPE_OSR]: '註冊海外公司',
        [KEY_LABEL_REPLY_TYPE_AS]: '會計服務',
        [KEY_LABEL_REPLY_TYPE_CS]: '公司秘書',
        [KEY_LABEL_REPLY_TYPE_SO]: '服務式辦公室',
        [KEY_LABEL_REPLY_TYPE_VO]: '虛擬辦公室',
        [KEY_LABEL_REPLY_TYPE_VA]: '增值服務',
    }
}